import { useState } from "react";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import "../../styles/footer.css";
import { AppAlert } from "../utilities/app-alert";
import { useAuth } from "../../services/authentication/authentication.context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faLinkedinIn, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";

const footerLinks = [
    {uri: "/courses", caption: 'Courses', auth: true},
    {uri: "/aichat", caption: "AI assistant", auth: true},
    {uri: "/contact", caption: 'Contact us', auth: false}
]

export const AppFooter = () => {

    const [onAlert, setOnAlert] = useState();

    const { isAuthenticated } = useAuth();

    const navigateTo = useNavigate();
    
    //handle navigation to quick link
    const handleNavigate = (link) => {
        if (link.auth) {
            if (!isAuthenticated) {
                setOnAlert({
                    caption: "Unauthorized!",
                    message: "Please sign in to access this page",
                    onAccept: () => navigateTo("/login"),
                    reject: "Exit"
                })
            }else{
                navigateTo(link.uri)
            }
        }else{
            navigateTo(link.uri)
        }
    }

    return (
        <footer className="app-footer">
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={"Ok"}
                    onAccept={onAlert.onAccept}
                    reject={onAlert.reject}
                    onReject={() => setOnAlert()}
                    closeAlert={() => setOnAlert()}
                />
            )}
            <div className="footer-top">
                <div 
                    className= {classNames(
                        'footer-div',
                        'app-name'
                    )}
                >
                    <div className="logo-box">
                        <img src="/sm-logo.png" alt="" width={80} />
                    </div>
                    <div className="app-name">
                        <span className="top-name">Pathfinders</span>
                        <span className="bottom-name">eSTEM hub</span>
                    </div>
                    <div className="social-cap">Follow us</div>
                    <div className="social-buttons">
                        <button className="social-button">
                            <FontAwesomeIcon icon={faFacebookF} />
                        </button>
                        <button className="social-button">
                            <FontAwesomeIcon icon={faXTwitter} />
                        </button>
                        <button className="social-button">
                            <FontAwesomeIcon icon={faInstagram} />
                        </button>
                        <button className="social-button">
                            <FontAwesomeIcon icon={faLinkedinIn} />
                        </button>
                    </div>
                </div>
                <div 
                    className={classNames('footer-div')}
                >
                    <div className="footer-cap">Quick Links</div>
                    <div className="link-list">
                        {footerLinks.map((link, i) => (
                            <button 
                                className="link-button" 
                                onClick={() => handleNavigate(link)}
                                key={i}
                            >
                                {link.caption}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="footer-div">
                    <div className="footer-cap">Contact Us</div>
                    <div className="contact-unit">
                        <FontAwesomeIcon icon={faEnvelope} />
                        <span className="contact-data">
                            p.stemhub@gmail.com
                        </span>
                    </div>
                    <div className="contact-unit">
                        <FontAwesomeIcon icon={faPhone} />
                        <span className="contact-data">
                            +237-676-86-26-20
                        </span>
                    </div>
                    <div className="contact-location">
                        <FontAwesomeIcon icon={faLocationDot} />
                        <span className="contact-data">
                            Alakuma, Bamenda-Cameroon 
                        </span>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="bottom-link">
                    Copywrite © Pathfinders eSTEM Hub {new Date().getFullYear()}
                </div>
                <div className="bottom-link">
                    Privacy policy
                </div>
            </div>
        </footer>
    )
}